import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/services/order/order.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-cancelorder',
  templateUrl: './cancelorder.component.html',
  styleUrls: ['./cancelorder.component.css']
})
export class CancelorderComponent implements OnInit {

  orderNo: string;
  orderHeader: any;
  data: any;
  isNotAgreed: boolean = true;
  orderConfirmed: boolean = false;

  isUserAdmin: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
    private orderServices: OrderService, private userService: UserService) {
    this.orderNo = this.route.snapshot.params.ordernumber;
    this.cancelOrder();
    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    //alert(this.orderNo);
  }

  ngOnInit() {
    this.getPlacedOrder();

  }

  cancelOrder() {
    this.orderServices.cancelOrder(this.orderNo).subscribe(
      (data: any) => {
        if (data == true) {
          this.getPlacedOrder();
        }
      }
    )
  }

  getPlacedOrder() {
    this.orderServices.getPlacedOrderItem(this.orderNo).subscribe(
      (data: any) => {
        this.orderHeader = data;
        this.data = this.orderHeader.orderDetail;
        console.log(this.orderHeader);
      }
    )
  }

  agreeCond(e) {
    if (e.target.checked) {
      this.isNotAgreed = false;
    }
    else {
      this.isNotAgreed = true;
    }
  }

  confirmOrder() {
    this.isNotAgreed = true;
    console.log(this.orderHeader);
    //alert("Order Confirmed");
    this.orderServices.confirmOrder(this.orderHeader).subscribe(
      (data: any) => {
        if (data == true) {

          //alert("Order Confirmed");
          this.orderConfirmed = true;
        }
        else {
          alert("Order Failed");
          this.orderConfirmed = false;
        }
      }
    )
  }

  // printRecipt(divName: string) {

  //   var printContents = document.getElementById(divName).innerHTML;
  //   var originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;

  //   window.print();

  //   document.body.innerHTML = originalContents;

  // }

  printRecipt() {

    //var printContents = document.getElementById(divName).innerHTML;
    //var originalContents = document.body.innerHTML;
    //document.body.innerHTML = printContents;
    //window.print();
    //document.body.innerHTML = originalContents;

    let printContents, popupWin;
    printContents = document.getElementById('printableContent').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Mother Parkers Tea &amp; Coffee Inc.</title>
          <style>
          #tabledata th
          {
            text-align:left;
          }
          body
          {
            margin-top:20px;
          }
          
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();

  }


  navigateOrderScreen() {
    this.router.navigate(['/myorders']);
  }

}
